module.exports = __webpack_public_path__ + "fannie-mae-card-bottom-right.1TV3komg.png";